import React from 'react'
import DialogModal from '../../shared/components/DialogModal'
import { useTranslation } from 'react-i18next'
import { FaCartShopping } from 'react-icons/fa6'

const SuccessModal = ({ isOpen, onClose, onOpenCart, title }) => {
    const { t } = useTranslation()

    const handleOpenCart = () => {
        onClose()
        onOpenCart()
    }

    return (
        <DialogModal isOpen={isOpen} onClose={onClose} title={title || t('projects.dialog.title')}>
            <div className='px-2 space-y-4 text-center sm:space-y-6 sm:px-0'>
                {/* Success Icon - Responsive sizing */}
                <div className='flex items-center justify-center w-12 h-12 mx-auto rounded-full sm:w-16 sm:h-16 bg-gradient-to-br from-green-100 to-emerald-100'>
                    <svg
                        className='w-6 h-6 text-green-600 sm:w-8 sm:h-8'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                    >
                        <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M5 13l4 4L19 7'
                        />
                    </svg>
                </div>

                {/* Title and Message - Responsive typography */}
                <div className='space-y-2'>
                    <h3 className='text-lg font-bold text-gray-900 sm:text-xl'>
                        {t('projects.dialog.title')}
                    </h3>
                    <p className='px-2 text-sm text-gray-600 sm:text-base sm:px-0'>
                        {t('projects.dialog.body')}
                    </p>
                </div>

                <div className='flex flex-col justify-between gap-3 pt-2 sm:flex-row'>
                    <button
                        onClick={handleOpenCart}
                        className='w-full px-4 py-3 sm:px-6 sm:py-2.5 border-2 border-gray-300 hover:border-gray-400 text-gray-700 hover:text-gray-900 font-medium rounded-lg transition-all duration-300 hover:bg-gray-50 active:bg-gray-100 flex items-center justify-center gap-2 sm:gap-3'
                    >
                        <FaCartShopping className='w-5 h-5 sm:w-4 sm:h-4' />
                        <span>{t('projects.dialog.cartButton')}</span>
                    </button>
                    <button
                        onClick={onClose}
                        className='w-full px-4 py-3 sm:px-6 sm:py-2.5 bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-white font-medium rounded-lg transition-all duration-300 active:scale-[0.98] sm:hover:scale-[1.02]'
                    >
                        {t('projects.dialog.continueButton')}
                    </button>
                </div>
            </div>
        </DialogModal>
    )
}

export default SuccessModal
